const Arrays = {
    filter: (source, attrName, values) => {
        let result = []
        if (!source) return
        values.forEach(filter => {
            source.forEach(item => {
                if (item[attrName] == filter) {
                    result.push(item)
                }
            })
        })
        return result
    },
    find: (source, attrName, value) => {
        let result = Arrays.filter(source, attrName, [value])
        return result.length != 0 ? result[0] : null
    },
   contains: (source, attrName, value) => {
        let result = Arrays.filter(source, attrName, [value])
        return result.length != 0
    },
}

export default Arrays